import React, { useState, useEffect } from 'react';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "Sustainability",
      description: "Building a greener future with eco-friendly transportation solutions",
      image: "https://placehold.co/1200x500/E62E2D/ffffff?text=Sustainability"
    },
    {
      id: 2,
      title: "Reliability",
      description: "Trusted by businesses across Pakistan for over two decades",
      image: "https://placehold.co/1200x500/E62E2D/ffffff?text=Reliability"
    },
    {
      id: 3,
      title: "Performance",
      description: "Engineered for excellence in every journey",
      image: "https://placehold.co/1200x500/E62E2D/ffffff?text=Performance"
    },
    {
      id: 4,
      title: "Innovation",
      description: "Leading-edge technology for superior driving experience",
      image: "https://placehold.co/1200x500/E62E2D/ffffff?text=Innovation"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="relative overflow-hidden">
      {slides.map((slide, index) => (
        <div 
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div 
            className="w-full h-[500px] bg-cover bg-center flex items-center"
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="container mx-auto px-4">
              <div className="bg-black bg-opacity-50 p-8 rounded-lg max-w-2xl">
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 animate-fadeIn">
                  {slide.title}
                </h1>
                <p className="text-xl text-white mb-6 animate-fadeIn delay-300">
                  {slide.description}
                </p>
                <button className="bg-[#E62E2D] text-white px-6 py-3 rounded-md hover:bg-[#cc2827] transition duration-300 animate-fadeIn delay-500">
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Slide Indicators */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full ${
              index === currentSlide ? 'bg-[#E62E2D]' : 'bg-white'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;